import { Configuration, PopupRequest } from '@azure/msal-browser'

/**
 * Entra must return the user to the host they signed in from: production serves the hub
 * from both hub.pg3-prod.coke.com and playground.coke.com, and MSAL keeps its login state
 * per origin. So only the path comes from REACT_APP_REDIRECT_URI; the origin is the page's.
 */
export const resolveRedirectUri = (configured: string | undefined, origin: string): string | undefined =>
  configured ? new URL(new URL(configured, origin).pathname, origin).href : undefined

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: resolveRedirectUri(process.env.REACT_APP_REDIRECT_URI, window.location.origin),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

export const loginRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_CLIENT_ID + '/.default'],
  // Enable refresh token by setting prompt to "none" for silent refresh
  extraScopesToConsent: ['offline_access'], // This enables refresh tokens
}

export const tokenRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_CLIENT_ID + '/.default'],
}
